import {
  isDevModeWithLocalMocks,
  navigateToScreenInDev,
} from "@/utils/helpers/devScreenNavigation";

interface UseBackNavigationOptions {
  devTarget: { parent: string; child: string };
  prodBack: () => void;
  prodCanGoBack?: boolean;
}

/**
 * Returns handleBack and canGoBack for screens with back navigation.
 * In dev mode, navigates via sessionStorage; otherwise calls prodBack.
 */
export function useBackNavigation({
  devTarget,
  prodBack,
  prodCanGoBack = false,
}: UseBackNavigationOptions): { handleBack: () => void; canGoBack: boolean } {
  const handleBack = () => {
    if (isDevModeWithLocalMocks()) {
      navigateToScreenInDev(devTarget.parent, devTarget.child);
      return;
    }
    prodBack();
  };

  const canGoBack = isDevModeWithLocalMocks() || prodCanGoBack;

  return { handleBack, canGoBack };
}
